var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3525_8528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3337 7.00033V2.25033C13.3337 1.8304 13.1668 1.42767 12.8699 1.13074C12.573 0.833807 12.1703 0.666992 11.7503 0.666992H7.00033C6.5804 0.666992 6.17767 0.833807 5.88074 1.13074C5.58381 1.42767 5.41699 1.8304 5.41699 2.25033V7.00033C5.41699 7.42025 5.58381 7.82298 5.88074 8.11991C6.17767 8.41684 6.5804 8.58366 7.00033 8.58366H11.7503C12.1703 8.58366 12.573 8.41684 12.8699 8.11991C13.1668 7.82298 13.3337 7.42025 13.3337 7.00033Z",
    stroke: "#7E8CA8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83366 5.41895H2.25033C1.8304 5.41895 1.42767 5.58576 1.13074 5.88269C0.833807 6.17963 0.666992 6.58235 0.666992 7.00228V11.7523C0.666992 12.1722 0.833807 12.5749 1.13074 12.8719C1.42767 13.1688 1.8304 13.3356 2.25033 13.3356H2.2527L7.0027 13.3277C7.42221 13.3271 7.82433 13.16 8.12075 12.8631C8.41717 12.5662 8.58366 12.1639 8.58366 11.7444V10.1666M4.62533 8.58561H2.25033",
    stroke: "#7E8CA8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8138 9.77148L5.02214 10.5632C4.75772 10.8268 4.09905 11.2226 3.04297 11.7507",
    stroke: "#7E8CA8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04297 8.58571C3.30739 9.50879 3.70322 10.169 4.23047 10.5641C4.75772 10.9591 5.41797 11.3542 6.20964 11.75M7.0013 7L9.3763 2.25L11.7513 7M10.9596 5.41667H7.79297",
    stroke: "#7E8CA8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3525_8528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.ba847c42bcb936c6c41c9547bf6a87b4.svg";
export { ForwardRef as ReactComponent };